module.exports = __webpack_public_path__ + "img/report-builder.6c5626de.gif";